import { CommonModalProps } from 'renderer/components/CommonModal/context';
import urls from 'constants/urls';
import { ModalCloseOptions } from './modalCloseOptions';

export const navigateTo = (url: string, location?: Location): void => {
  const target = location ?? window.location;
  target.href = url;
};

export const modalSeverityValues = {
  INFO: 'info', // general information modal
  ERROR: 'error', // a modal shown due to an error
  CONFLICT: 'conflict', // usually a BE triggered error e.g. trolley conflict
} as const;

export const createNetworkErrorModal = (navigate?: (url: string) => void): CommonModalProps => {
  const navigateFn = navigate ?? navigateTo;

  return {
    id: 'networkErrorModal',
    severity: modalSeverityValues.ERROR,
    buttons: [
      {
        buttonText: 'Go to Homepage',
        buttonValue: ModalCloseOptions.OK,
        onClick: () => navigateFn(urls.homepage),
      },
    ],
    messageText: [
      'These problems are normally temporary. Please refresh the page, restart your browser or try again a little later.',
    ],
    titleText: "Sorry, we're experiencing an unexpected error.",
    cannotClose: true,
  };
};

export const networkErrorModal: CommonModalProps = createNetworkErrorModal();

export const createUnexpectedErrorModal = () => {
  return {
    ...networkErrorModal,
    id: 'unexpectedErrorModal',
    buttons: [
      {
        buttonText: 'OK',
        buttonValue: ModalCloseOptions.OK,
        onClick: () => {
          window.location.reload();
        },
      },
    ],
  };
};

export const unexpectedErrorModal: CommonModalProps = createUnexpectedErrorModal();
